import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Podcastlisting(porps) {
  return (
    <div className="podcast_listing tekrevol_gray_bg p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="mb-5">
            <div className="example" data-text="Podcast Ep">
              <h2>Latest Episodes</h2>
            </div>
            <p>
              We collaborate with entrepreneurs and industry leaders to
              emphasize the importance of digital transformation. We regularly
              invite technopreneurs and change leaders to talk about how
              technology played a crucial role in transforming their businesses
              and how it helps them scale up with sustainability.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="podcast_list">
              <h4>
                How Can Technology Implementations Improve Educational
                Institution Processes?
              </h4>
              <div className="podcast_txt">
                <p>
                  Tekrevol's Managing Partner Daniel Burgess is joined by
                  Lillian Row, a Baltimore County Board of Education member...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-ep8"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="podcast_list">
              <h4>
                What Does Automation Mean for a Business in The 21st century?
              </h4>
              <div className="podcast_txt">
                <p>
                  In Episode 7, Tekrevol’s Co-Founder and CMO Abeer Raza is
                  joined by the Co-Founder of Remote New Media and Code
                  Assembly, Mr.Paul McGillivray...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-ep7"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="podcast_list">
              <h4>How To Get Investors To Say “YES” To Your Startup!</h4>
              <div className="podcast_txt">
                <p>
                  In episode #06, we are joined by the founder of Slidebean,
                  Jose Caya, to discuss the importance of pitch decks to
                  increase market excitement about your product...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-ep6"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Podcastlisting;
